import React, { useEffect, useState } from 'react';
import authService from './api-authorization/AuthorizeService';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table'; 

const AssetConditionAssessments = (param) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [assetID, setAssetID] = useState(null);
    const [assessmentDate, setAssessmentDate] = useState("");
    const [fullAssessment, setFullAssessment] = useState("");
    const [assessmentNotes, setAssessmentNotes] = useState("");
    const [conditionAssessments, setConditionAssessments] = useState([]);
    const [crvHistory, setcrvHistory] = useState([]);
    

    useEffect(() => {

        async function getAuth() {
            const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);

            if (!isAuthenticated) {
                setUser('Invalid');
            } else {
                setUser(user.name);
            }
        }

        const getAssetID = () => {
            setAssetID(param.assetId);
        };

        getAuth();
        getAssetID();
    }, [param.assetId]);

    useEffect(() => {

        async function fetchConditionAssessments() {
            if (!assetID) {
                setLoading(false); 
                return;
            }

            try {
                const token = await authService.getAccessToken();
                const response = await fetch(`api/assets/assessment?id=${assetID}`, {
                    method: 'GET',
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(`Error Response: ${errorText}`);
                    throw new Error(`HTTP Error: ${response.status}`);
                }

                if (response.status === 200) {
                    const data = await response.json();

                    await setConditionAssessments(data);
                }

            } catch (error) {
                console.error("Error fetching condition assessments:", error);
                alert("An error occurred while fetching assessments.");
            } finally {
                setLoading(false);
            }

        }

        fetchConditionAssessments();

    }, [assetID]);


    const handleInputChange = (event) => {
        const { id, value } = event.target;

        switch (id) {
            case 'assessmentDate':
                setAssessmentDate(value);
                break;
            case 'fullAssessment':
                setFullAssessment(Number(value));
                break;
            case 'assessmentNotes':
                setAssessmentNotes(value);
                break;
            default:
                console.warn(`Unhandled input change for id: ${id}`);
        }
    };

    const handleSaveAssessment = async (event) => {
        event.preventDefault();

        if (!assetID || fullAssessment === null || !assessmentDate || !assessmentNotes || !user) {
            alert("All fields are required!");
            return;
        }

        const assessmentStruct = {
            AssetID: assetID,
            AssessmentDate: assessmentDate,
            FullAssessment: fullAssessment.toString(),
            AssessmentNotes: assessmentNotes,
            EnteredBy: user,
        };

        const success = await saveAssessment(assessmentStruct);
        if (success) {
            setAssessmentDate("");
            setFullAssessment("");
            setAssessmentNotes("");

            fetchConditionAssessments();
        }
    };

    const saveAssessment = async (assessment) => {
        try {
            const token = await authService.getAccessToken();
            const response = await fetch("api/assets/addAssessment", {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(assessment),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error("API error:", errorData);
                alert("Error: " + (errorData.title || "Failed to save assessment."));
                return false;
            }

            return true;
        } catch (error) {
            console.error("Error saving assessment:", error);
            alert("An error occurred while saving.");
            return false;
        }
    };

    const fetchConditionAssessments = async () => {
        if (!assetID) {
            setLoading(false);
            return;
        }

        try {
            const token = await authService.getAccessToken();
            const response = await fetch(`api/assets/assessment?id=${assetID}`, {
                method: "GET",
                headers: !token ? {} : { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error(`Error Response: ${errorText}`);
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const data = await response.json();
            setConditionAssessments(data);
        } catch (error) {
            console.error("Error fetching condition assessments:", error);
            alert("An error occurred while fetching assessments.");
        } finally {
            setLoading(false);
        }
    };

    return loading ? (
        <p><em>Loading...</em></p>
    ) : (
        <React.Fragment>
            <style>{`
                .uniform-height {
                    height: calc(1.5em + 0.75rem + 2px);
                } 
                .larger-textarea {
                    height: calc(3em + 1.5rem + 4px); /* Twice the height of the others */
                }
                `
            }</style>
            <Card>
                <Card.Header>Record Assessment</Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSaveAssessment}>
                        <Row>
                            <Col sm="6">
                                <Form.Group as={Row} controlId="assessmentDate">
                                    <Form.Label column sm={6}>Assessment Date</Form.Label>
                                    <Col sm={6}>
                                        <InputGroup>
                                            <Form.Control
                                                //id="assessmentDate"
                                                type="date"
                                                value={assessmentDate}
                                                onChange={handleInputChange}
                                                min="1000-01-01"
                                                max="9999-12-31"
                                                required
                                                className="uniform-height"
                                            />
                                        </InputGroup>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="fullAssessment">
                                    <Form.Label column sm={6}>Full Assessment</Form.Label>
                                    <Col sm={6}>
                                        <InputGroup>
                                            <Form.Select
                                                //id="fullAssessment"
                                                value={fullAssessment}
                                                onChange={handleInputChange}
                                                required
                                                className="uniform-height"
                                            >
                                                <option value="" disabled>Select a Requirement Type/Issue...</option>
                                                <option value={1}>Yes</option>
                                                <option value={0}>No</option>
                                            </Form.Select>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Control
                                    id="assessmentNotes"
                                    as="textarea"
                                    value={assessmentNotes}
                                    onChange={handleInputChange}
                                    placeholder="Assessment Notes"
                                    required
                                    className="larger-textarea"
                                />
                            </Col>
                            </Row>
                        <Button type="submit">Save Assessment</Button>
                    </Form>
                </Card.Body>
                </Card>
                <p></p>
                <h5>Assessment History</h5>
                <Table striped>
                    <thead>
                        <tr>
                            <th>Assessment Date</th>
                            <th>Full Assessment</th>
                            <th>Notes</th>
                            <th>Entered By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conditionAssessments.length > 0 ? (
                            conditionAssessments.map(assessment => (
                                <tr key={assessment.id}>
                                    <td>{new Date(assessment.assessmentDate).toLocaleDateString('en-US')}</td>
                                    <td>{assessment.fullAssessment === '1' ? 'Yes' : 'No'}</td>
                                    <td>{assessment.assessmentNotes}</td>
                                    <td>{assessment.enteredBy}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4">No assessments available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
        </React.Fragment>
    );
};

export default AssetConditionAssessments;
